var render, staticRenderFns
import script from "./TableCommon.vue?vue&type=script&lang=js&"
export * from "./TableCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ce61a55')) {
      api.createRecord('4ce61a55', component.options)
    } else {
      api.reload('4ce61a55', component.options)
    }
    
  }
}
component.options.__file = "src/mixins/TableCommon.vue"
export default component.exports